<template>
  <div class="bg auth-screen">
    <div class="container pt-100">
      <div v-if="!mailSent" class="card">
        <div class="card-body">
          <h2 class="card-title" v-translate:pweb_title_verify_identity="lang">
            Verify Identity
          </h2>
          <div class="card-description">We've sent a six-digit confirmation code to {{ mobileNo }} email.</div>
          <form class="otp_form">
            <div class="form-group otp-input-group">
              <label>Enter Code</label>
              <div class="row">
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_1"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_1'),
                      'is-success': !errors.has('otp_1')
                    }"
                    class=" form-control form-control-sm "
                    v-model="otp_1"
                    maxlength="1"
                    id="otp_1"
                    v-on:keyup="validatePassKey(1, $event)"
                    v-on:paste="handleOtpPaste($event)"
                    required
                    tabindex="-1"
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_2"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_2'),
                      'is-success': !errors.has('otp_2')
                    }"
                    class="form-control form-control-sm "
                    v-model="otp_2"
                    maxlength="1"
                    id="otp_2"
                    v-on:keyup="validatePassKey(2, $event)"
                    v-on:paste="handleOtpPaste($event)"
                    required
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_3"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_3'),
                      'is-success': !errors.has('otp_3')
                    }"
                    class="form-control form-control-sm  "
                    v-model="otp_3"
                    maxlength="1"
                    id="otp_3"
                    v-on:keyup="validatePassKey(3, $event)"
                    v-on:paste="handleOtpPaste($event)"
                    required
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_4"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_4'),
                      'is-success': !errors.has('otp_4')
                    }"
                    class="form-control form-control-sm "
                    v-model="otp_4"
                    maxlength="1"
                    id="otp_4"
                    v-on:keyup="validatePassKey(4, $event)"
                    v-on:paste="handleOtpPaste($event)"
                    required
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_5"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_5'),
                      'is-success': !errors.has('otp_5')
                    }"
                    class="form-control form-control-sm "
                    v-model="otp_5"
                    maxlength="1"
                    id="otp_5"
                    v-on:keyup="validatePassKey(5, $event)"
                    v-on:paste="handleOtpPaste($event)"
                    required
                  />
                </div>
                <div class="col-lg-2 mr-0">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_6"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_6'),
                      'is-success': !errors.has('otp_6')
                    }"
                    class="form-control form-control-sm "
                    v-model="otp_6"
                    maxlength="1"
                    id="otp_6"
                    v-on:keyup="validatePassKey(6, $event)"
                    v-on:paste="handleOtpPaste($event)"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="success-msg-style" v-if="successMsg">
                {{ successMsg }}
              </div>
              <div class="error-style" v-if="errorMsg">{{ errorMsg }}</div>
              <div>
                <button type="submit" class="btn btn-primary btn-block" :disabled="disableSubmitButton" v-on:click.prevent="submitOtp">
                  Continue
                </button>
              </div>
            </div>
            <div class="footer-links">
              <a v-on:click="resendOTP" v-translate:label_resend_code="lang">Resend code</a>
            </div>
          </form>
        </div>
      </div>
      <div class="card" v-else>
        <div class="card-body p-52">
          <div class="text-center mb-21">
            <img src="static/img/green-circled-check-large.svg" class="checkmark" />
          </div>
          <h2 class="card-title">Username Sent</h2>
          <div class="card-description">
            An email has been sent with your username. You should now be able to sign in to your study on your device.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import otpInputMixin from "@/mixins/otpInputMixin";

export default {
  name: "verifyIdentity",
  mixins: [otpInputMixin],
  data() {
    return {
      otp_1: "",
      otp_2: "",
      otp_3: "",
      otp_4: "",
      otp_5: "",
      otp_6: "",
      otp: "",
      formErrors: false,
      correctOTP: false,
      successMsg: null,
      errorMsg: null,
      mobileNo: null,
      token: null,
      tokeType: null,
      mailSent: false,
      apiCallInProgress: false
    };
  },
  computed: {
    ...mapGetters(["appStateClientId"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    disableSubmitButton() {
      if (this.otp_1 == "" || this.otp_2 == "" || this.otp_3 == "" || this.otp_4 == "" || this.otp_5 == "" || this.otp_6 == "") {
        return true;
      } else if (this.errors.any()) {
        return true;
      } else if (this.apiCallInProgress) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.mobileNo = this.$route.params.mobile ? `${this.$route.params.mobile} and your` : "your";
    this.token = this.$route.params.token;
    if (this.$route.query.tokenType && this.$route.query.tokenType != "") {
      this.tokenType = this.$route.query.tokenType;
    }
    if (this.appStateClientId && this.token) {
      this.sendOtpToMobile();
    }
  },
  methods: {
    submitOtp() {
      if (this.tokenType == "FORGOT_USERNAME_OTP") {
        this.verifyforgotUsernameOtp();
      } else if (this.tokenType == "CREATE_USERNAME_OTP") {
        this.confirmOTP();
      }
    },
    sendOtpToMobile() {
      const postData = {
        token: this.token
      };
      if (this.tokenType) {
        postData.tokenType = this.tokenType;
      }
      this.apiCallInProgress = true;
      this.$api.sendOtpToMobileFact(postData).then(
        () => {
          this.errorMsg = null;
          this.apiCallInProgress = false;
        },
        error => {
          this.apiCallInProgress = false;
          this.successMsg = null;
          this.errorMsg = error.body && error.body.message ? error.body.message : "Error while sending OTP to mobile";
        }
      );
    },
    confirmOTP() {
      this.apiCallInProgress = true;
      this.otp = this.otp_1 + this.otp_2 + this.otp_3 + this.otp_4 + this.otp_5 + this.otp_6;
      this.$api
        .verifyOtpFact({
          token: this.token,
          otp: this.otp
        })
        .then(
          response => {
            this.apiCallInProgress = false;
            this.correctOTP = true;
            this.errorMsg = null;
            this.successMsg = response.body.message;

            this.$router.push({
              name: "create-username",
              params: {
                token: this.token
              }
            });
          },
          error => {
            this.apiCallInProgress = false;
            if (error.status === 409) {
              this.$router.push({
                name: "expire-link"
              });
            }
            this.$store.dispatch("confirmOtpErrorAction", {
              token: this.token,
              otp: this.otp
            });
            this.successMsg = null;
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while confirming the OTP";
          }
        );
    },
    resendOTP() {
      this.apiCallInProgress = true;
      this.errorMsg = null;
      this.successMsg = null;
      const postData = {
        token: this.token
      };
      if (this.tokenType) {
        postData.tokenType = this.tokenType;
      }
      this.$api.sendOtpToMobileFact(postData).then(
        () => {
          this.apiCallInProgress = false;
          this.successMsg = "Code resent";
        },
        error => {
          this.apiCallInProgress = false;
          this.errorMsg = error.body && error.body.message ? error.body.message : "Error while resending the OTP";
        }
      );
    },
    verifyforgotUsernameOtp() {
      this.apiCallInProgress = true;
      this.otp = this.otp_1 + this.otp_2 + this.otp_3 + this.otp_4 + this.otp_5 + this.otp_6;
      this.$api
        .verifyForgottenUsername({
          otp: this.otp
        })
        .then(
          response => {
            this.apiCallInProgress = false;
            this.correctOTP = true;
            this.errorMsg = null;
            this.successMsg = response.body.message;
            this.mailSent = true;
            setTimeout(() => {
              this.$router.push({
                name: "login"
              });
            }, 5000);
          },
          error => {
            this.apiCallInProgress = false;
            if (error.status === 409) {
              this.$router.push({
                name: "expire-link"
              });
            }
            this.$store.dispatch("confirmOtpErrorAction", {
              token: this.token,
              otp: this.otp
            });
            this.successMsg = null;
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while confirming the OTP";
          }
        );
    }
  }
};
</script>

<style lang="scss" scoped>
.link-style {
  font-size: 14px;
  text-align: center;
  padding-top: 5px;
}

.error-style {
  font-size: 12px;
  color: #ffa500;
  padding-bottom: 15px;
  text-align: center;
}

.success-msg-style {
  font-size: 12px;
  color: #449d44;
  padding-bottom: 15px;
  text-align: center;
}
</style>
<style scoped lang="scss" src="@/assets/auth-screen.scss"></style>
